export const turnReadyNotification = {
    type: 'turn-ready',
    name: 'Turn Ready',
    description: "Sent when it's your turn in a game.",
    defaultEnabled: true,
    text(data, context) {
        if (data.turns?.length > 1) {
            return `You have ${data.turns.length} games waiting for your move.${context === 'push' ? ' Tap to play!' : ''}`;
        }
        const gameName = data.turns?.[0].gameTitle ?? 'Rout';
        return `Ready to make your move in ${gameName}?${context === 'push' ? ' Tap to play!' : ''}`;
    },
    title() {
        return `Your turn!`;
    },
    link(data) {
        return data.turns?.length === 1
            ? `/session/${data.turns[0].gameSessionId}`
            : '/#online-games';
    },
};
//# sourceMappingURL=turnReady.js.map